export enum AdmStaticFilterType {
  FLOOR = 'floor',
  TAG = 'tag'
}

export const admStaticFilterConfigs: AdmStaticFilterConfig[] = [
  { type: AdmStaticFilterType.FLOOR, label: 'Filter by floor(s)', formKey: 'floor', color: 'green', dataCy: 'floor' },
  { type: AdmStaticFilterType.TAG, label: 'Filter by tag(s)', formKey: 'tag', color: 'red', dataCy: 'tag' }
];

export interface AdmStaticFilterConfig {
  type: AdmStaticFilterType;
  label: string;
  formKey: string;
  color: string;
  dataCy: string;
}
